<div class="wallet-check-container">
  <div class="wallet-check-content">
    <olv-wallet-check-form [merchantId]="merchantId()"></olv-wallet-check-form>
  </div>
</div>
